module.exports = __webpack_public_path__ + "static/media/Magneton_gaussian2.d6dc8553.png";